import { j as l } from "./AccesRecoveryIcon-CUPieIxT.js";
const s = () => /* @__PURE__ */ l.jsx("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ l.jsx(
  "path",
  {
    d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20m-.88-32.654L9.4 24.84l12.36-5.505zm8.04 9.665L20.92 6l2.64 12.601zm1.08 1.835-4.32 2.08L25.6 29H34zM23.68 29l-1.44-7.34L7 29z",
    fillRule: "evenodd",
    fill: "currentColor"
  }
) });
export {
  s as X
};
